define.alias("ember-basic-dropdown/components/basic-dropdown-trigger", "media/components/basic-dropdown-trigger");